
    const data = {"name":"src/core/icons/format-align-center","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M3 3h18v2H3V3m4 4h10v2H7V7m-4 4h18v2H3v-2m4 4h10v2H7v-2m-4 4h18v2H3v-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            